"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDeliverablesTab = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const UI_1 = require("../util/UI");
const AdminPage_1 = require("./AdminPage");
const AdminView_1 = require("./AdminView");
const DockerListImageView_1 = require("./DockerListImageView");
class AdminDeliverablesTab extends AdminPage_1.AdminPage {
    constructor(remote, isAdmin) {
        super(remote);
        this.isAdmin = isAdmin;
    }
    setAdmin(isAdmin) {
        Log_1.default.info("AdminDeliverablesTab::isAdmin( " + isAdmin + " )");
        this.isAdmin = isAdmin;
    }
    init(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminDeliverablesTab::init(..) - start");
            UI_1.UI.showModal("Retrieving deliverables.");
            const delivs = yield AdminDeliverablesTab.getDeliverables(this.remote);
            this.render(delivs);
            UI_1.UI.hideModal();
        });
    }
    render(deliverables) {
        Log_1.default.info("AdminDeliverablesTab::render(..) - start");
        const deliverableList = document.querySelector("#adminDeliverablesList");
        if (deliverableList === null) {
            Log_1.default.info("AdminDeliverablesTab::render(..) - list not on screen; skipping");
            return;
        }
        deliverableList.innerHTML = "";
        deliverableList.appendChild(UI_1.UI.createListHeader("Deliverables"));
        for (const deliv of deliverables) {
            const main = "Deliverable: " + deliv.id;
            const sub = "Opens: " + new Date(deliv.openTimestamp).toLocaleString() + "; Closes: " + new Date(deliv.closeTimestamp).toLocaleString();
            let editable = false;
            if (this.isAdmin === true) {
                editable = true;
            }
            const elem = UI_1.UI.createListItem(main, sub, editable);
            elem.setAttribute("delivId", deliv.id);
            elem.onclick = function (evt) {
                const delivId = evt.currentTarget.getAttribute("delivId");
                UI_1.UI.pushPage("editDeliverable.html", { delivId: delivId })
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.error("UI::pushPage(..) - ERROR: " + err.message);
                });
            };
            deliverableList.appendChild(elem);
        }
        if (deliverables.length === 0) {
            deliverableList.appendChild(UI_1.UI.createListItem("Deliverables not yet specified."));
        }
        this.wireActions(deliverables);
    }
    wireActions(deliverables) {
        const that = this;
        const button = (id) => document.querySelector("#" + id);
        const createDeliverable = button("adminCreateDeliverableButton");
        if (createDeliverable !== null) {
            createDeliverable.onclick = function () {
                UI_1.UI.pushPage("editDeliverable.html", { delivId: null })
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.error("UI::pushPage(..) - ERROR: " + err.message);
                });
            };
        }
        const deleteSelect = document.querySelector("#adminDeleteDeliverableSelect");
        if (deleteSelect !== null) {
            const ids = deliverables.map((d) => d.id).sort();
            UI_1.UI.setDropdownOptions("adminDeleteDeliverableSelect", ["-Select-"].concat(ids), "-Select-");
        }
        const deleteDeliverable = button("adminDeleteDeliverableSelectButton");
        if (deleteDeliverable !== null) {
            deleteDeliverable.onclick = function () {
                that.deleteSelectedDeliverable().catch(function (err) {
                    UI_1.UI.showError(err.message);
                });
            };
        }
        const download = button("adminDownloadDeliverablesButton");
        if (download !== null) {
            download.onclick = function () {
                that.downloadConfiguration().catch(function (err) {
                    UI_1.UI.showError(err.message);
                });
            };
        }
        const upload = button("adminUploadDeliverablesButton");
        if (upload !== null) {
            upload.onclick = function () {
                that.uploadConfiguration().catch(function (err) {
                    UI_1.UI.showError(err.message);
                });
            };
        }
    }
    deleteSelectedDeliverable() {
        return __awaiter(this, void 0, void 0, function* () {
            const delivId = UI_1.UI.getDropdownValue("adminDeleteDeliverableSelect");
            if (typeof delivId !== "string" || delivId === "-Select-" || delivId.length === 0) {
                UI_1.UI.showAlert("Select a deliverable to delete.");
                return;
            }
            const that = this;
            UI_1.UI.notificationConfirm("Delete deliverable " + delivId + "? Its grades and results are kept.", function (choice) {
                return __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    var _b;
                    if (choice !== 1) {
                        return;
                    }
                    try {
                        const options = AdminView_1.AdminView.getOptions();
                        options.method = "delete";
                        const response = yield fetch(that.remote + "/portal/admin/deliverable/" + encodeURIComponent(delivId), options);
                        const body = yield response.json();
                        if (typeof body.success === "undefined") {
                            throw new Error((_b = (_a = body === null || body === void 0 ? void 0 : body.failure) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "HTTP " + response.status);
                        }
                        UI_1.UI.showSuccessToast("Deliverable deleted: " + delivId);
                        yield that.init({});
                    }
                    catch (err) {
                        Log_1.default.error("AdminDeliverablesTab::deleteSelectedDeliverable( " + delivId + " ) - ERROR: " + err.message);
                        UI_1.UI.showError("Unable to delete " + delivId + ": " + err.message);
                    }
                });
            });
        });
    }
    downloadConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            const deliverables = yield AdminDeliverablesTab.getDeliverables(this.remote);
            const file = {
                kind: AdminDeliverablesTab.CONFIG_KIND,
                exported: new Date().toISOString(),
                deliverables: deliverables,
            };
            const blob = new Blob([JSON.stringify(file, null, 2)], { type: "application/json" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = "classy-deliverables-" + new Date().toISOString().slice(0, 10) + ".json";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
            Log_1.default.info("AdminDeliverablesTab::downloadConfiguration() - " + deliverables.length + " deliverables");
        });
    }
    uploadConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            var _b;
            const input = document.querySelector("#adminUploadDeliverablesFile");
            if (input === null || input.files === null || input.files.length === 0) {
                UI_1.UI.showAlert("Select a deliverable configuration file first.");
                return;
            }
            let parsed;
            try {
                parsed = JSON.parse(yield input.files[0].text());
            }
            catch (_err) {
                UI_1.UI.showAlert("That file is not valid JSON.");
                return;
            }
            if ((parsed === null || parsed === void 0 ? void 0 : parsed.kind) !== AdminDeliverablesTab.CONFIG_KIND || Array.isArray(parsed.deliverables) === false) {
                UI_1.UI.showAlert("That file is not a Classy deliverable configuration; use one saved by the download above.");
                return;
            }
            const entries = parsed.deliverables;
            UI_1.UI.showModal("Uploading deliverables.");
            const existing = new Set((yield AdminDeliverablesTab.getDeliverables(this.remote)).map((d) => d.id));
            const added = [];
            const skipped = [];
            const failed = [];
            for (const entry of entries) {
                const id = typeof (entry === null || entry === void 0 ? void 0 : entry.id) === "string" ? entry.id : null;
                if (id === null || id.length < 2) {
                    failed.push(JSON.stringify(entry).slice(0, 40) + " (no id)");
                    continue;
                }
                if (existing.has(id)) {
                    skipped.push(id);
                    continue;
                }
                try {
                    const options = AdminView_1.AdminView.getOptions();
                    options.method = "post";
                    options.body = JSON.stringify(entry);
                    const response = yield fetch(this.remote + "/portal/admin/deliverable", options);
                    const body = yield response.json();
                    if (typeof body.success === "undefined") {
                        throw new Error((_b = (_a = body === null || body === void 0 ? void 0 : body.failure) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "HTTP " + response.status);
                    }
                    added.push(id);
                    existing.add(id);
                }
                catch (err) {
                    Log_1.default.error("AdminDeliverablesTab::uploadConfiguration( " + id + " ) - ERROR: " + err.message);
                    failed.push(id + " (" + err.message + ")");
                }
            }
            UI_1.UI.hideModal();
            input.value = "";
            let summary = "Added " + added.length + " deliverable" + (added.length === 1 ? "" : "s") + ".";
            if (skipped.length > 0) {
                summary += " Skipped, already exist: " + skipped.join(", ") + ".";
            }
            if (failed.length > 0) {
                summary += " Failed: " + failed.join("; ") + ".";
            }
            Log_1.default.info("AdminDeliverablesTab::uploadConfiguration() - " + summary);
            if (failed.length > 0) {
                UI_1.UI.showAlert(summary);
            }
            else {
                UI_1.UI.notificationToast(summary, 8000);
            }
            yield this.init({});
        });
    }
    initEditDeliverablePage(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminView::initEditDeliverablePage( " + JSON.stringify(opts) + " ) - start");
            const delivId = opts.delivId;
            if (delivId === null) {
                this.renderEditDeliverablePage(null);
            }
            else {
                const deliverables = yield AdminDeliverablesTab.getDeliverables(this.remote);
                for (const deliv of deliverables) {
                    if (deliv.id === delivId) {
                        this.renderEditDeliverablePage(deliv);
                        return;
                    }
                }
            }
        });
    }
    updateHiddenBlocks() {
        const shouldProvision = document.querySelector("#adminEditDeliverablePage-shouldProvision");
        const provisionValue = shouldProvision.checked;
        Log_1.default.info("AdminView::renderEditDeliverablePage(..)::updateHiddenBocks::shouldProvision; value: " + provisionValue);
        const provisionList = document.querySelector("#shouldProvisionList");
        if (provisionValue === true) {
            provisionList.style.display = "inherit";
        }
        else {
            provisionList.style.display = "none";
        }
        const shouldAutoTest = document.querySelector("#adminEditDeliverablePage-shouldAutoTest");
        const autoTestValue = shouldAutoTest.checked;
        Log_1.default.info("AdminView::renderEditDeliverablePage(..)::updateHiddenBlocks::shouldAutoTest; value: " + autoTestValue);
        const autoTestList = document.querySelector("#shouldAutoTestList");
        if (autoTestValue === true) {
            autoTestList.style.display = "inherit";
        }
        else {
            autoTestList.style.display = "none";
        }
    }
    renderEditDeliverablePage(deliv) {
        Log_1.default.info("AdminView::renderEditDeliverablePage( " + JSON.stringify(deliv) + " ) - start");
        const that = this;
        const fab = document.querySelector("#adminEditDeliverableSave");
        if (this.isAdmin === false) {
            fab.style.display = "none";
        }
        else {
            fab.onclick = function (_evt) {
                Log_1.default.info("AdminView::renderEditDeliverablePage(..)::adminEditDeliverableSave::onClick");
                that
                    .save()
                    .then(function () {
                })
                    .catch(function (err) {
                    Log_1.default.error("AdminView::renderEditDeliverablePage(..)::adminEditDeliverableSave::onClick - ERROR: " + err.message);
                    UI_1.UI.showError("Could not save the deliverable: " + err.message);
                });
            };
        }
        const shouldProvision = document.querySelector("#adminEditDeliverablePage-shouldProvision");
        shouldProvision.onchange = function (evt) {
            const value = evt.value;
            Log_1.default.info("AdminView::renderEditDeliverablePage(..)::adminEditDeliverableSave::shouldProvision; change: " + value);
            that.updateHiddenBlocks();
        };
        const shouldAutoTest = document.querySelector("#adminEditDeliverablePage-shouldAutoTest");
        shouldAutoTest.onchange = function (evt) {
            const value = evt.value;
            Log_1.default.info("AdminView::renderEditDeliverablePage(..)::adminEditDeliverableSave::shouldAutoTest; change: " + value);
            that.updateHiddenBlocks();
        };
        const pickerOptions = function (timestamp) {
            const options = {
                enableTime: true,
                time_24hr: true,
                utc: true,
                dateFormat: "Y/m/d @ H:i",
            };
            if (typeof timestamp === "number" && Number.isFinite(timestamp) === true) {
                const date = new Date(timestamp);
                if (isNaN(date.getTime()) === false) {
                    options.defaultDate = date;
                }
                else {
                    Log_1.default.warn("AdminDeliverablesTab::pickerOptions(..) - unusable timestamp: " + timestamp);
                }
            }
            return options;
        };
        let selectedDockerImage = "";
        if (deliv === null) {
            this.openPicker = flatpickr("#adminEditDeliverablePage-open", pickerOptions(Date.now()));
            this.closePicker = flatpickr("#adminEditDeliverablePage-close", pickerOptions(Date.now()));
            UI_1.UI.setDropdownSelected("adminEditDeliverablePage-minTeamSize", 1, this.isAdmin);
            UI_1.UI.setDropdownSelected("adminEditDeliverablePage-maxTeamSize", 1, this.isAdmin);
            this.setToggle("adminEditDeliverablePage-inSameLab", true, this.isAdmin);
            this.setToggle("adminEditDeliverablePage-studentsMakeTeams", false, this.isAdmin);
            this.setToggle("adminEditDeliverablePage-gradesReleased", false, this.isAdmin);
            this.setToggle("adminEditDeliverablePage-visible", false, this.isAdmin);
            this.setToggle("adminEditDeliverablePage-lateAutoTest", false, this.isAdmin);
            this.setToggle("adminEditDeliverablePage-shouldAutoTest", true, this.isAdmin);
            this.setTextField("adminEditDeliverablePage-atContainerTimeout", "300", this.isAdmin);
            this.setTextField("adminEditDeliverablePage-atStudentDelay", 12 * 60 * 60 + "", this.isAdmin);
            this.setTextField("adminEditDeliverablePage-atCustom", "{}", this.isAdmin);
            this.setToggle("adminEditDeliverablePage-shouldProvision", true, this.isAdmin);
            this.setTextField("adminEditDeliverablePage-importURL", "", this.isAdmin);
            this.setTextField("adminEditDeliverablePage-repoPrefix", "", this.isAdmin);
            this.setTextField("adminEditDeliverablePage-teamPrefix", "", this.isAdmin);
            this.setTextField("adminEditDeliverablePage-rubric", "{}", this.isAdmin);
            this.setTextField("adminEditDeliverablePage-custom", "{}", this.isAdmin);
        }
        else {
            this.setTextField("adminEditDeliverablePage-name", deliv.id, false);
            this.setTextField("adminEditDeliverablePage-url", deliv.URL, this.isAdmin);
            this.setTextField("adminEditDeliverablePage-repoPrefix", deliv.repoPrefix, this.isAdmin);
            this.setTextField("adminEditDeliverablePage-teamPrefix", deliv.teamPrefix, this.isAdmin);
            this.openPicker = flatpickr("#adminEditDeliverablePage-open", pickerOptions(deliv.openTimestamp));
            this.closePicker = flatpickr("#adminEditDeliverablePage-close", pickerOptions(deliv.closeTimestamp));
            this.setToggle("adminEditDeliverablePage-lateAutoTest", deliv.lateAutoTest, this.isAdmin);
            this.setToggle("adminEditDeliverablePage-shouldProvision", deliv.shouldProvision, this.isAdmin);
            this.setTextField("adminEditDeliverablePage-importURL", deliv.importURL, this.isAdmin);
            UI_1.UI.setDropdownSelected("adminEditDeliverablePage-minTeamSize", deliv.minTeamSize, this.isAdmin);
            UI_1.UI.setDropdownSelected("adminEditDeliverablePage-maxTeamSize", deliv.maxTeamSize, this.isAdmin);
            this.setToggle("adminEditDeliverablePage-inSameLab", deliv.teamsSameLab, this.isAdmin);
            this.setToggle("adminEditDeliverablePage-studentsMakeTeams", deliv.studentsFormTeams, this.isAdmin);
            this.setToggle("adminEditDeliverablePage-gradesReleased", deliv.gradesReleased, this.isAdmin);
            this.setToggle("adminEditDeliverablePage-visible", deliv.visibleToStudents, this.isAdmin);
            this.setToggle("adminEditDeliverablePage-shouldAutoTest", deliv.shouldAutoTest, this.isAdmin);
            this.setTextField("adminEditDeliverablePage-atContainerTimeout", deliv.autoTest.maxExecTime + "", this.isAdmin);
            this.setTextField("adminEditDeliverablePage-atStudentDelay", deliv.autoTest.studentDelay + "", this.isAdmin);
            this.setTextField("adminEditDeliverablePage-atRegressionIds", deliv.autoTest.regressionDelivIds.toString(), this.isAdmin);
            this.setTextField("adminEditDeliverablePage-atCustom", JSON.stringify(deliv.autoTest.custom), this.isAdmin);
            this.setTextField("adminEditDeliverablePage-rubric", JSON.stringify(deliv.rubric), this.isAdmin);
            this.setTextField("adminEditDeliverablePage-custom", JSON.stringify(deliv.custom), this.isAdmin);
            selectedDockerImage = deliv.autoTest.dockerImage;
        }
        that.updateHiddenBlocks();
        const newImageSha = UI_1.UI.getCurrentPage().data.sha;
        if (newImageSha) {
            selectedDockerImage = newImageSha;
        }
        const list = document.querySelector("#docker-image-list");
        const dataSource = {
            url: this.remote + "/portal/at/docker/images?filters=" + JSON.stringify({ reference: ["grader"] }),
            options: AdminView_1.AdminView.getOptions(),
        };
        const state = {
            checkedItemSha: selectedDockerImage,
        };
        new DockerListImageView_1.DockerListImageView(list).bind(dataSource, state).catch(function (err) {
            UI_1.UI.showErrorToast("Docker images: " + err);
        });
        document.querySelector("#btnNewImage").onclick = function () {
            UI_1.UI.pushPage("createDockerImage.html")
                .then(function () {
                let imageSha;
                document.querySelector("#create-docker-image-back").onClick = function () {
                    UI_1.UI.popPage({ data: { sha: imageSha } });
                };
                document.querySelector("#build-image-form").onsubmit = function () {
                    const contextInput = document.querySelector("#docker-image-context-input");
                    const tagInput = document.querySelector("#docker-image-tag-input");
                    const fileInput = document.querySelector("#docker-image-file-input");
                    const submit = document.querySelector("#build-image-button");
                    const context = contextInput.value;
                    const tag = "grader" + (tagInput.value ? ":" + tagInput.value : "");
                    const file = fileInput.value;
                    contextInput.disabled = true;
                    tagInput.disabled = true;
                    fileInput.disabled = true;
                    submit.disabled = true;
                    UI_1.UI.showModal();
                    that
                        .buildDockerImage(context, tag, file)
                        .then(function (sha) {
                        imageSha = sha;
                        UI_1.UI.hideModal();
                    })
                        .catch(function (err) {
                        return __awaiter(this, void 0, void 0, function* () {
                            yield UI_1.UI.showAlert(err.message);
                            contextInput.disabled = false;
                            tagInput.disabled = false;
                            fileInput.disabled = false;
                            submit.disabled = false;
                            UI_1.UI.hideModal();
                        });
                    });
                    return false;
                };
            })
                .catch(function (err) {
                Log_1.default.error("UI::pushPage(..) - ERROR: " + err.message);
            });
        };
    }
    setTextField(fieldName, textValue, editable) {
        const field = document.querySelector("#" + fieldName);
        if (field !== null) {
            field.value = textValue;
            if (editable === false) {
                field.setAttribute("readonly", "");
            }
        }
        else {
            Log_1.default.error("AdminDeliverablesTab::setTextField( " + fieldName + ", ... ) - element does not exist");
        }
    }
    setToggle(fieldName, value, editable) {
        const field = document.querySelector("#" + fieldName);
        if (field !== null) {
            field.checked = value;
            if (editable === false) {
                field.setAttribute("readonly", "");
            }
        }
        else {
            Log_1.default.error("AdminDeliverablesTab::setToggle( " + fieldName + ", ... ) - element does not exist");
        }
    }
    static selectedTimestamp(picker) {
        var _a;
        var _b;
        const selected = (_b = picker === null || picker === void 0 ? void 0 : picker.latestSelectedDateObj) !== null && _b !== void 0 ? _b : (_a = picker === null || picker === void 0 ? void 0 : picker.selectedDates) === null || _a === void 0 ? void 0 : _a[0];
        if (typeof selected === "undefined" || selected === null || isNaN(selected.getTime()) === true) {
            return null;
        }
        return selected.getTime();
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminDeliverablesTab::save() - start");
            const id = UI_1.UI.getTextFieldValue("adminEditDeliverablePage-name");
            const URL = UI_1.UI.getTextFieldValue("adminEditDeliverablePage-url");
            const openTimestamp = AdminDeliverablesTab.selectedTimestamp(this.openPicker);
            const closeTimestamp = AdminDeliverablesTab.selectedTimestamp(this.closePicker);
            if (openTimestamp === null || closeTimestamp === null) {
                const which = openTimestamp === null ? "Open" : "Close";
                UI_1.UI.showError(which + " date is not set. Pick a date and time, then save again.");
                return;
            }
            const shouldProvision = UI_1.UI.getToggleValue("adminEditDeliverablePage-shouldProvision");
            const importURL = UI_1.UI.getTextFieldValue("adminEditDeliverablePage-importURL");
            const minTeamSize = Number(UI_1.UI.getDropdownValue("adminEditDeliverablePage-minTeamSize"));
            const maxTeamSize = Number(UI_1.UI.getDropdownValue("adminEditDeliverablePage-maxTeamSize"));
            const teamsSameLab = UI_1.UI.getToggleValue("adminEditDeliverablePage-inSameLab");
            const studentsFormTeams = UI_1.UI.getToggleValue("adminEditDeliverablePage-studentsMakeTeams");
            const gradesReleased = UI_1.UI.getToggleValue("adminEditDeliverablePage-gradesReleased");
            const visibleToStudents = UI_1.UI.getToggleValue("adminEditDeliverablePage-visible");
            const lateAutoTest = UI_1.UI.getToggleValue("adminEditDeliverablePage-lateAutoTest");
            const shouldAutoTest = UI_1.UI.getToggleValue("adminEditDeliverablePage-shouldAutoTest");
            const dockerImage = this.readDockerImage("docker-image");
            const maxExecTime = Number(UI_1.UI.getTextFieldValue("adminEditDeliverablePage-atContainerTimeout"));
            const studentDelay = Number(UI_1.UI.getTextFieldValue("adminEditDeliverablePage-atStudentDelay"));
            const repoPrefix = UI_1.UI.getTextFieldValue("adminEditDeliverablePage-repoPrefix");
            const teamPrefix = UI_1.UI.getTextFieldValue("adminEditDeliverablePage-teamPrefix");
            const atRegression = UI_1.UI.getTextFieldValue("adminEditDeliverablePage-atRegressionIds");
            const regressionDelivIds = [];
            if (atRegression.length > 0) {
                const parts = atRegression.split(",");
                for (const p of parts) {
                    regressionDelivIds.push(p);
                }
            }
            let atCustomRaw = UI_1.UI.getTextFieldValue("adminEditDeliverablePage-atCustom");
            let atCustom = {};
            if (atCustomRaw.length > 0) {
                Log_1.default.trace("AdminDeliverablesTab::save() - atCustomRaw: " + atCustomRaw);
                atCustomRaw = atCustomRaw.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ');
                try {
                    atCustom = JSON.parse(atCustomRaw);
                }
                catch (err) {
                    UI_1.UI.showError("AutoTest Custom field is not valid JSON: " + err.message);
                    throw new Error("Cancel back");
                }
            }
            const customRaw = UI_1.UI.getTextFieldValue("adminEditDeliverablePage-custom");
            let custom = {};
            if (customRaw.length > 0) {
                Log_1.default.trace("AdminDeliverablesTab::save() - customRaw: " + customRaw);
                try {
                    custom = JSON.parse(customRaw);
                }
                catch (err) {
                    UI_1.UI.showError("Custom field is not valid JSON: " + err.message);
                    throw new Error("Cancel back");
                }
            }
            const rubricRaw = UI_1.UI.getTextFieldValue("adminEditDeliverablePage-rubric");
            let rubric = {};
            if (rubricRaw.length > 0) {
                Log_1.default.trace("AdminDeliverablesTab::save() - customRaw: " + customRaw);
                try {
                    rubric = JSON.parse(rubricRaw);
                }
                catch (err) {
                    UI_1.UI.showError("Rubric field is not valid JSON: " + err.message);
                    throw new Error("Cancel back");
                }
            }
            const at = {
                dockerImage,
                maxExecTime,
                studentDelay,
                regressionDelivIds,
                custom: atCustom,
                openTimestamp,
                closeTimestamp,
                lateAutoTest,
            };
            const deliv = {
                id,
                URL,
                visibleToStudents,
                openTimestamp,
                closeTimestamp,
                onOpenAction: "",
                onCloseAction: "",
                lateAutoTest,
                shouldAutoTest,
                importURL,
                minTeamSize,
                maxTeamSize,
                studentsFormTeams,
                teamsSameLab,
                gradesReleased,
                shouldProvision,
                autoTest: at,
                repoPrefix,
                teamPrefix,
                rubric,
                custom,
            };
            Log_1.default.trace("AdminDeliverablesTab::save() - result: " + JSON.stringify(deliv));
            const url = this.remote + "/portal/admin/deliverable";
            const options = AdminView_1.AdminView.getOptions();
            options.method = "post";
            options.body = JSON.stringify(deliv);
            const response = yield fetch(url, options);
            const body = yield response.json();
            if (typeof body.success !== "undefined") {
                UI_1.UI.showSuccessToast("Deliverable saved successfully.");
                UI_1.UI.popPage();
            }
            else {
                UI_1.UI.showError(body);
            }
        });
    }
    readDockerImage(fieldName) {
        const checkedRadio = document.querySelector("input[name='" + fieldName + "']:checked");
        if (!checkedRadio) {
            return null;
        }
        const label = document.querySelector("label[for=" + checkedRadio.id + "]");
        return label.firstElementChild.children[0].innerHTML;
    }
    static getDeliverables(remote) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                Log_1.default.info("AdminDeliverablesTab::getDeliverables( .. ) - start");
                const start = Date.now();
                const options = AdminView_1.AdminView.getOptions();
                const url = remote + "/portal/admin/deliverables";
                const response = yield fetch(url, options);
                if (response.status === 200) {
                    Log_1.default.trace("AdminDeliverablesTab::getDeliverables(..) - 200 received");
                    const json = yield response.json();
                    if (typeof json.success !== "undefined" && Array.isArray(json.success)) {
                        Log_1.default.trace("AdminDeliverablesTab::getDeliverables(..)  - worked; took: " + UI_1.UI.took(start));
                        return json.success;
                    }
                    else {
                        Log_1.default.trace("AdminDeliverablesTab::getDeliverables(..)  - ERROR: " + json.failure.message);
                        AdminView_1.AdminView.showError(json.failure);
                    }
                }
                else {
                    Log_1.default.trace("AdminDeliverablesTab::getDeliverables(..)  - !200 received: " + response.status);
                    const text = yield response.text();
                    AdminView_1.AdminView.showError(text);
                }
            }
            catch (err) {
                AdminView_1.AdminView.showError("Getting deliverables failed: " + err.message);
            }
            return [];
        });
    }
    buildDockerImage(context, tag, file) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                Log_1.default.info("AdminDeliverablesTab::buildDockerImage(..) - start");
                const remote = this.remote;
                const output = yield UI_1.UI.templateDisplayText("dockerBuildDialog.html", "Initializing Docker build. Please wait...\n\n");
                const url = remote + "/portal/at/docker/image";
                const options = AdminView_1.AdminView.getOptions();
                options.method = "POST";
                options.keepalive = true;
                options.body = JSON.stringify({ remote: context, tag: tag, file: file });
                Log_1.default.info("AdminDeliverablesTab::buildDockerImage(..) - url: " + url);
                Log_1.default.trace("AdminDeliverablesTab::buildDockerImage(..) - options: " + JSON.stringify(options));
                let lines = [];
                const atResponse = yield fetch(url, options);
                Log_1.default.info("AdminDeliverablesTab::buildDockerImage(..) - sent");
                const reader = atResponse.body.getReader();
                Log_1.default.info("AdminDeliverablesTab::buildDockerImage(..) - reading");
                try {
                    while (true) {
                        try {
                            const { done, value } = yield reader.read();
                            const valueString = new TextDecoder().decode(value, { stream: true });
                            Log_1.default.trace("AdminDeliverablesTab::buildDockerImage(..) - chunk raw: " + valueString);
                            const chunkLines = valueString
                                .split("\n")
                                .filter((s) => s !== "")
                                .map((s) => JSON.parse(s))
                                .filter((s) => s.hasOwnProperty("stream") || s.hasOwnProperty("message") || s.hasOwnProperty("error"))
                                .map((s) => s.stream || s.message || "\n\nError code: " + s.errorDetail.code + "\n\nError Message: " + s.error);
                            lines = lines.concat(chunkLines);
                            const newLines = chunkLines.join("");
                            output.innerText += newLines;
                            output.scrollTop = output.scrollHeight;
                            Log_1.default.info("AdminDeliverablesTab::buildDockerImage(..) - chunk string: " + newLines);
                            if (done) {
                                Log_1.default.info("AdminDeliverablesTab::buildDockerImage(..) - stream done");
                                break;
                            }
                        }
                        catch (err) {
                            Log_1.default.warn("AdminDeliverablesTab::buildDockerImage(..) - ERROR decoding stream: " + err.message);
                        }
                    }
                }
                catch (err) {
                    Log_1.default.info("AdminDeliverablesTab::buildDockerImage(..) - stream ERROR: " + err.message);
                }
                Log_1.default.info("AdminDeliverablesTab::buildDockerImage(..) - reading complete");
                output.innerText += "\n";
                output.innerText += "\n";
                output.scrollTop = output.scrollHeight;
                const SUCCESS_LINE = 2;
                if (lines.length > SUCCESS_LINE && lines[lines.length - SUCCESS_LINE].startsWith("Successfully built")) {
                    const sha = lines[lines.length - SUCCESS_LINE].replace("Successfully built ", "").trim();
                    Log_1.default.info("AdminDeliverablesTab::buildDockerImage(..) - final sha: " + sha);
                    UI_1.UI.popPage({ data: { sha: sha } });
                    return Promise.resolve(sha);
                }
                else {
                    return Promise.reject(new Error("Failed to read image SHA from build log. " +
                        "If the image was built successfully, you can manually select it on the previous screen."));
                }
            }
            catch (err) {
                AdminView_1.AdminView.showError("An error occurred making request: " + err.message);
            }
        });
    }
}
exports.AdminDeliverablesTab = AdminDeliverablesTab;
AdminDeliverablesTab.CONFIG_KIND = "classy-deliverables";
